export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  RESEND_VERIFICATION: '/resend-verification',
  DASHBOARD: '/dashboard',
  CATALOG: '/catalog',
  MANUAL_ORDER: '/registrar-pedido',
  TRACK_ORDER: '/seguimiento',
  PRODUCT_DETAIL: '/product/:slug',
  CART: '/cart',
  CHECKOUT: '/checkout',
  CHECKOUT_SUCCESS: '/checkout/success',
  CHECKOUT_FAILURE: '/checkout/failure',
  CHECKOUT_PENDING: '/checkout/pending',
  PROFILE: '/profile',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:id',
  THEMES: '/themes',
  RECOMMENDATIONS: '/recommendations',
  CONTACT: '/contact',
  SHIPPING: '/shipping',
  RETURNS: '/returns',
  FAQ: '/faq',
  PRIVACY: '/privacy',
  // Vendor routes
  VENDOR: {
    DASHBOARD: '/vendor',
    PRODUCTS: '/vendor/products',
    PRODUCT_CREATE: '/vendor/products/new',
    PRODUCT_EDIT: '/vendor/products/:id',
    ORDERS: '/vendor/orders',
    ORDER_DETAIL: '/vendor/orders/:id',
  },
  // Admin routes
  ADMIN: {
    DASHBOARD: '/admin',
    PRODUCTS: '/admin/products',
    PRODUCT_CREATE: '/admin/products/new',
    PRODUCT_EDIT: '/admin/products/:id',
    ORDERS: '/admin/orders',
    ORDER_CREATE: '/admin/orders/new',
    ORDER_DETAIL: '/admin/orders/:id',
    ATTRIBUTES: '/admin/attributes',
    COUPONS: '/admin/coupons',
    COUPON_CREATE: '/admin/coupons/new',
    COUPON_EDIT: '/admin/coupons/:id',
    SHIPPING: '/admin/shipping',
    TEMPLATES: '/admin/templates',
  },
} as const;
